import { IdManagerIfc } from '../IdManagerIfc';
import { BitBoardEntity } from '../../../utils/BitBoardEntity';

export class AbstractBitBoardSet32 implements IdManagerIfc{ 
    public static MAX_INT_VALUE = 2147483647;
	public static REST_MASK:number = parseInt("11111", 2);
		private static k:number;
		private static p:number;
		
		protected static powers:Array<number>;

		static initialize(){
			AbstractBitBoardSet32.powers = new Array();
			
			for ( AbstractBitBoardSet32.k = 0; AbstractBitBoardSet32.k <= 15; AbstractBitBoardSet32.k++ ) {
				AbstractBitBoardSet32.p = AbstractBitBoardSet32.pow( 32, AbstractBitBoardSet32.k);
				AbstractBitBoardSet32.powers[AbstractBitBoardSet32.k] = BitBoardEntity.numberOfTrailingZeros(AbstractBitBoardSet32.p);
			}	
		}
		
		public static pow( base:number, pow:number ):number{
			let ret:number = 1;
			for (let i:number = 0; i < pow; i++ ) {
				ret *= base;
			}
			return ret;
		}
		
		
		longTree:Array<Array<number>>;
		
		currentTreeLevel:number;
		
		currentSize:number;
		maxCapacity:number;
		
		initialLoad:boolean;
		initialIdx:number;
		
		constructor() 
		{
			this.initTree();
		}
		
		initTree():void{
			this.currentTreeLevel = 1;
			this.currentSize = 0;
			this.maxCapacity = 32;
			this.initialLoad = true;
			this.initialIdx = 0;
			this.longTree = [];
			this.longTree[0] = [];
			this.longTree[0][0] = 0;
			this.longTree[1] = [];
			this.longTree[1][0] = 0;
		}
		
		protected expand( oldTree:Array<Array<number>>, force:boolean ):void{
			this.expandTree( force );
			//it is enought to rewrite old to new array as AS has ability to extend array automagically
			//also it rewrites only old arraySSS pointer to new array
			var oldNewOffset:number = oldTree.length == this.longTree.length ? 0 : -1;
			for ( let i:number = this.currentTreeLevel; i > 0; i--){
				this.longTree[ i ] = oldTree[i + oldNewOffset];
				var currentLength:number = this.longTree[ i ].length;
				for ( var j:number = currentLength; j < currentLength * 2; j++ ) {
					this.longTree[ i ][ j ] = 0;
				}
			}
			this.maxCapacity *= 2;
		}
		
		
		protected expandTree( force:boolean ):void{
			if ( ~this.longTree[0][0] == 0 || force ) {
				this.currentTreeLevel++;
				this.longTree = [];
				
				this.longTree[ 0 ] = [];
				this.longTree[ 0 ][ 0 ] = 1;
			}
		}
		
		
		public isAllocated( id:number ):boolean{
			let currentBucket:number = id >> 5;
			let idx:number = id & AbstractBitBoardSet32.REST_MASK;
			if( currentBucket >= this.longTree[ this.currentTreeLevel ].length ){
				return false;
			}
			var currentIdx:number = 1 << idx;
			let allocated:boolean = (this.longTree[ this.currentTreeLevel ][ currentBucket ] & currentIdx ) == currentIdx;
			return allocated;
		}
		
		public freeIds( ids:Array<number>):void{
			for ( let id of ids ){
				this.free(id);
			}
		}
		
		public reset():void{
			this.initTree();
		}
		
		public size():number{
			return this.currentSize;
		}
		
		public getNodeSizeOnEachLevel():Array<number>{
			var nodesSize:Array<number> = new Array();
			for ( let i:number = 0; i < this.longTree.length; i++) {
				nodesSize[ i ] = this.longTree[ i ].length;
			}
			return nodesSize;
		}
		
		public allocateConcrete( id:number ):void{
			if( id < 0 ){
				throw new Error("Id must be above 0, you try to set concreteId: " + id );
			}
			if ( id > ((AbstractBitBoardSet32.MAX_INT_VALUE - 5 ) * 32 ) ) {
				throw new Error("You try to allocate value above limit: " + id );
			}
			var maxHeight:number = 1;
			for( var i:number = 32; i <= id; i *= 32, maxHeight++ ){};
			while( maxHeight > this.longTree.length ){
				this.expand( this.longTree, true );
			}
				
			while( this.maxCapacity <= id ){
				this.expand( this.longTree, false );
			}
			this.initialLoad = false;
			this.currentSize++;
			this.allocateConcreteInternal( 0, id );
		}
		protected allocateConcreteInternal( height:number, id:number ):void{
			throw new Error("Not allowed to invooke.");
		}
		public free( id:number ):void{
			throw new Error("Not allowed to invooke.");
		}
		public allocate( ):number{
			throw new Error("Not allowed to invooke.");
		}
		public allocateIds( lenght:number ):Array<number>{
			throw new Error("Not allowed to invooke.");
		}
			
		public nextSetBit( id:number ):number {
			throw new Error("Not allowed to invooke.");
		}
}

AbstractBitBoardSet32.initialize();